import { Chip } from "@material-ui/core";
import { memo } from "react";
import { useFluxoDeCaixaService } from "../contexts";

const FinanceChip = ({ financeCategory }) => {
  const {
    financeCategoriesFilter,
    cachedFinanceCategories,
    setCachedFinanceCategories,
    applyFinanceFilter,
    filters,
  } = useFluxoDeCaixaService();

  const hasChildren = (parentId) =>
    cachedFinanceCategories.some((category) => category.parentId === parentId);

  const handleChildrenCheck = ({ parent, child, checked, parents }) => {
    if (parents.includes(child.parentId)) {
      return { ...child, checked };
    }

    if (
      child.id === parent.id ||
      (child.id === parent.parentId && !child.checked)
    ) {
      return { ...child, checked };
    }

    return child;
  };

  const handleCheck = (category, checked) => {
    const parents = [category.id];

    cachedFinanceCategories
      .filter((child) => child.parentId === category.id)
      .forEach((child) => {
        const isParent = hasChildren(child.id);
        if (isParent) {
          parents.push(child.id);
        }
      });

    const checkedCategories = cachedFinanceCategories.map((c) =>
      handleChildrenCheck({ checked, parent: category, child: c, parents })
    );

    setCachedFinanceCategories(checkedCategories);

    applyFinanceFilter(filters.useFinanceCategories, checkedCategories);
  };

  const isParent = hasChildren(financeCategory.id);
  const children = financeCategoriesFilter.filtered
    .filter((category) => category.parentId === financeCategory?.id)
    .map((category) => <FinanceChip financeCategory={category} />);
  return (
    <>
      <Chip
        key={financeCategory.id}
        label={financeCategory.desc}
        onDelete={() => {
          handleCheck(financeCategory, false);
        }}
        variant={isParent ? "outlined" : "default"}
        color={isParent ? "secondary" : "primary"}
      />
      {children}
    </>
  );
};

export default memo(FinanceChip);
